import { OperationTypes } from 'utils/enums/system-template';
import { GuardData } from './guard.model';

const operationGuard = (pageTypeTemplate: OperationTypes | OperationTypes[]): ((guardData: GuardData) => boolean) => {
  return (guestGuard: GuardData) => {
    if (Array.isArray(pageTypeTemplate)) {
      return pageTypeTemplate.includes(guestGuard.operationType);
    } else {
      return pageTypeTemplate === guestGuard.operationType;
    }
  };
};

export default operationGuard;
